import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
import { roleSchema } from './role.js';
/**
 * Payload du jeton d'accès (M23) : `sub` porte l'identifiant utilisateur, `teamId` n'existe
 * que pour une session terrain avec équipe choisie (M6) — absent pour un jeton back-office,
 * qui voit tout et filtre par équipe à l'écran. Rien de plus : pas de permissions détaillées
 * dans le jeton, elles ne sont pas encore définies (Q9).
 */
export const accessTokenPayloadSchema = z.object({
    sub: uuidV7Schema,
    role: roleSchema,
    teamId: uuidV7Schema.optional(),
});
//# sourceMappingURL=access-token.js.map